import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

const ConfirmOrderModal = ({ modelTitle, openModel, handleModelClose, addonsClass = '', modelHeaderHide = false, children, orderNo, slug }) => {
    return (
        <div className={cn('modal confirm-order ff-modal', addonsClass, openModel && 'active')}>
            {modelHeaderHide && modelHeaderHide == true ? (
                <>{children}</>
            ) : (
                <div className="modal-dialog max-w-[360px] relative">
                    <button className="modal-close fa-regular fa-circle-xmark absolute top-5 right-5" onClick={() => handleModelClose()}></button>
                    <div className="modal-body">
                        <h3 className="capitalize text-base font-medium text-center mt-2 mb-3">Thank you for your order!</h3>
                        <img className="w-[120px] mx-auto mb-3" src={'/assets/images/cart/confirm.gif'} alt="gif" />
                        <h3 className="capitalize text-lg font-medium text-center mb-3 text-primary">Order Confirmed</h3>
                        <p className="text-sm leading-6 mb-4">
                            Your order is currently confirmed as
                            <b className="font-medium"> Dining Table.</b>
                        </p>
                        <Link to={`/menu/table-order/${slug}/${orderNo}`} className="w-full rounded-3xl text-center font-medium leading-6 py-3 text-white bg-primary">
                            Go to Details
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConfirmOrderModal;
